// Centralised brand asset URLs and constants for Aurum Vanguard.

export const BRAND = {
    logoMonogramGoldOnWhite:
        "https://customer-assets.emergentagent.com/job_c1821d0e-c0ad-43e4-a804-dd1bfdffc8e0/artifacts/lenm06p0_44A64648-9B21-40EA-BFAE-9EA243E05C4A.png",
    team: {
        raul: "https://customer-assets.emergentagent.com/job_agentes-ia-preview/artifacts/b2szogfo_E775B7FA-0B2B-4E5F-86DF-8E960C788C70.png",
        sergio: "https://customer-assets.emergentagent.com/job_agentes-ia-preview/artifacts/7a18hrg3_96B69142-D685-45C1-8A3E-305BCFA3AB04.png",
        simei: "https://customer-assets.emergentagent.com/job_c1821d0e-c0ad-43e4-a804-dd1bfdffc8e0/artifacts/uqn5gb54_F79A910F-A324-48AB-BCF2-553AC7147753.png",
        omar: "https://customer-assets.emergentagent.com/job_agentes-ia-preview/artifacts/fg105lye_81224796-2ea6-445d-a2ac-5b96ead8ab65.jpeg",
    },
    contact: {
        email: "hello@aurumvanguard.com",
        location: "Dubai, Emiratos Árabes Unidos",
    },
    calBookingUrl: "https://cal.com/aurumvanguardmeeting",
};

export const PRODUCT_LABEL = {
    core: "Aurum Core",
    pro: "Aurum Pro",
    imperium: "Aurum Imperium",
    no_se_aun: "No lo sé aún",
};

export const SECTOR_OPTIONS = [
    { value: "inmobiliario", label: "Inmobiliario" },
    {
        value: "servicios_profesionales",
        label: "Servicios profesionales regulados",
    },
    { value: "salud_bienestar", label: "Salud y bienestar premium" },
    { value: "financiero", label: "Financiero e intermediación" },
    { value: "otro", label: "Otro" },
];

export const PRODUCT_OPTIONS = [
    { value: "core", label: "Aurum Core" },
    { value: "pro", label: "Aurum Pro" },
    { value: "imperium", label: "Aurum Imperium" },
    { value: "no_se_aun", label: "No lo sé aún" },
];
